import React from 'react'
import { businessInfoReviewCollectionPath } from 'components/routes/path'

interface GetMoreReviewsButtonProps {
  slug: string
}

export const GetMoreReviewsButton: React.FC<GetMoreReviewsButtonProps> = ({ slug }) => {
  const buttonText: string = 'Get More Reviews'

  return (
    <span>
      <a
        className='button icon-button pro-rounded pro-orange-400 pro-closest-shadow supplier-profile-button'
        href={businessInfoReviewCollectionPath(slug)}
        target='_blank'
        rel='noreferrer'
      >
        {buttonText}
      </a>
    </span>
  )
}
